// extracted by css-extract-rspack-plugin
export default {"imageWrapper":"_d3a0d5cd","popularSearchLink":"_79117212"};